<template>
  <fieldset class="flex flex-row items-center">
    <!-- <span class="mr-2">{{desc}}</span> -->
    <input
      class="form form-control flex-grow-0 w-auto mr-2"
      type="text"
      v-model="labelComputed"
      :disabled="disabledLabel"
      v-if="showLabel"
    />
    <input
      type="file"
      :id="id"
      class="hidden"
      @change="handelChange"
      :accept="acceptFile"
    />
    <label :for="id" class="flex-grow" :class="{'mr-4' : !isPlainInput}">
      <div
        class="flex flex-row cursor-pointer rounded border"
        :class="{'border-gray-500' : !isPlainInput}"
        v-if="!isEmptyModelValue"
      >
        <div class="p-2 text-theme-38 font-bold rounded-l" :class="isPlainInput ? 'border-r' : ' bg-gray-400'">
          เลือก
        </div>
        <div class="p-2 text-theme-38 rounded-r w-full" :class="{'bg-gray-300':!isPlainInput}">
          {{isPlainInput ? 'ไม่ได้เลือกไฟล์':'ไม่ได้เลือกเอกสาร'}}
        </div>
      </div>
      <div
        class="flex flex-row cursor-pointer rounded border border-gray-500"
        v-else
      >
        <div class="p-2 bg-gray-300 text-theme-38 rounded-r w-full">
          {{ fileName }}
        </div>
      </div>
    </label>
    <button
      v-if="!hideDeleteButton"
      class="btn btn-danger"
      @click="clickDelete"
    >
      - ลบ
    </button>
  </fieldset>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  modelValue: { type: [Object, null], default: null },
  id: {
    type: String,
    default: "inputFile",
  },
  label: {
    type: String,
    default: "",
  },
  disabledLabel: {
    type: Boolean,
    default: false,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
  hideDeleteButton: {
    type: Boolean,
    default: false,
  },
  acceptFile: {
    type: String,
    default: "image/*,application/pdf",
  },
  isPlainInput:{
    type: Boolean,
    default: false
  }
});
const emits = defineEmits([
  "update:modelValue",
  "click:delete",
  "update:label",
]);

const isEmptyModelValue = computed(() => {
  return !!props.modelValue;
});

const fileName = computed(() =>
  props.modelValue.name ? props.modelValue.name : props.modelValue.file_name
);

const labelComputed = computed({
  get() {
    return props.label;
  },
  set(val) {
    emits("update:label", val);
  },
});

const handelChange = (evt) => {
  emits("update:modelValue", evt.target.files[0]);
};
const clickDelete = () => {
  emits("click:delete");
};
</script>
